import PageSEO from '@/shared/PageSEO/PageSEO';
import SubscriptionsForTeachers from '../../src/components/pages/Subscriptions/SubscriptionsForTeachers';

export default function TeacherSubscriptions() {
  return (
    <>
      <PageSEO
        title="Teacher Subscription Types | Rockalingua"
        description="Save time and have super engaged students. "
        includeSchemaMarkup
      />
      <SubscriptionsForTeachers />
    </>
  );
}
